import React, { forwardRef } from "react";
import styles from "../subjects.module.css";
import { get } from "util/requests";
import moment from "moment-timezone";
import { useSelector } from "react-redux";

const DownloadSubjectsMenu = (props, ref) => {
  const { selectedDomain, selectedColumns, all_column_set_all, all_columns_domain } = props;
  const active_study_id = useSelector((state) => state.study.active_study_id);
  const downloadSubjects = () => {
    get("/download_subjects", {
      params: {
        // columns: selectedColumns.join(","),
        // domain_code: selectedDomain,
        study_id: active_study_id,
      },
    }).then((ret) => {
      const anchor = document.createElement("a");
      const type = "data:application/octet-stream";
      const url = "test.csv";
      const filename = `${ret.data.filename} - ${moment().format("YYYY-MM-DD HHmmss")}.csv`;
      const newWindow = true;

      anchor.setAttribute("href", `${type},${encodeURIComponent(ret.data.data)}`);
      anchor.setAttribute("download", filename);
      anchor.style.display = "none";
      anchor.textContent = url;

      if (newWindow) {
        anchor.setAttribute("target", "_blank");
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });
  };
  return (
    <div className={styles.hover_menu} ref={ref}>
      <div className={styles.menu_button} onClick={downloadSubjects}>
        CSV
      </div>
    </div>
  );
};

export default forwardRef(DownloadSubjectsMenu);
